import SmallScreenComponent from "../SmallScreenComponent";
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row} from "reactstrap";
import LargeScreenComponent from "../LargeScreenComponent";
import React, {useState} from "react";
import {SearchInformation} from "../../types/graphql/searchInformation";
import {useMutation} from "@apollo/react-hooks";
import REGISTER_EMAIL_FOR_COTTAGE_UPDATES from "../../graphql/mutations/registerEmailForUpdatesSelectedSearchFilter";
import {FilterSelection} from "../../types/filterSelection";
import {useRouter} from "next/router";
import ModalHeader from "../Modal/ModalHeader";

interface EmailUpdatesButtonProps {
    searchInformation: SearchInformation
}

const emailRegex = /\S+@\S+\.\S+/;

const validateEmail = (email) => {
    if (emailRegex.test(email)) {
        return true
    } else {
        return false
    }
};

const Body = ({searchInformation, setEmail, data, loading}: {searchInformation: SearchInformation, setEmail: (email) => void, data: any, loading: boolean}) => {
    if (data && data.registerEmailForUpdatesCottageSearchFilter.status) {
        return <div>Gegevens verzonden</div>;
    }

    if (data && !data.registerEmailForUpdatesCottageSearchFilter.status) {
        return <div>Deze zoekopdracht is al geregistreerd voor uw email adres</div>;
    }

    return (
        <>
        {searchInformation.selectedFilters &&
                <>
                    <p>Onvang per email de nieuwste cottage's voor uw huidige zoekopdracht.</p>
                    <h4>Uw zoekopdracht:</h4>
                    {searchInformation.destinationSummary &&
                    <div>
                        <b>Bestemming:</b> <br/>{searchInformation.destinationSummary}
                    </div>
                    }
                    {searchInformation.datesSummary &&
                    <div>
                        <b>Aankomt en vertrek:</b> <br/>{searchInformation.datesSummary}
                    </div>
                    }
                    {searchInformation.partySummary &&
                    <div>
                        <b>Reisgezelshap:</b> <br/>{searchInformation.partySummary}
                    </div>
                    }
                    {searchInformation.filterSummary &&
                    <div>
                        <b>Filters:</b> <br/>{searchInformation.filterSummary}
                    </div>
                    }

                    <Form className="mt-4">
                        <FormGroup>
                            <Label className="h4" for="exampleEmail">Uw Email</Label>
                            <Input onChange={(event) => setEmail(event.target.value)} type="email" name="email" id="exampleEmail" placeholder="uw-email@test.nl" />
                        </FormGroup>
                    </Form>
                </>
        }
        </>
    )
}

const EmailUpdatesButton = ({ searchInformation}: EmailUpdatesButtonProps) => {
    const router = useRouter();
    const [mobileModal, setMobileModal] = useState(false);
    const [modal, setModal] = useState(false);
    const toggleMobile = () => setMobileModal(!mobileModal);
    const toggle = () => setModal(!modal);
    const [email, setEmail] = useState('');
    const [saveLastSelectedSearchFilter, {data, loading}] = useMutation(REGISTER_EMAIL_FOR_COTTAGE_UPDATES);

    const onSend = (): void => {
        const searchSelection = FilterSelection.fromUrlParams(router);
        saveLastSelectedSearchFilter({
            variables: {
                email: email,
                searchFilter: searchSelection.toGraphQLFilterInput()
            },
        })
    }

    return (
        <>
            <SmallScreenComponent>
                <div className="text-xsm">
                    {searchInformation.destinationSummary &&
                    <div>
                        <b>Bestemming:</b> <br/>{searchInformation.destinationSummary}
                    </div>
                    }
                    {searchInformation.datesSummary &&
                    <div>
                        <b>Aankomt en vertrek:</b> <br/>{searchInformation.datesSummary}
                    </div>
                    }
                    {searchInformation.partySummary &&
                    <div>
                        <b>Reisgezelshap:</b> <br/>{searchInformation.partySummary}
                    </div>
                    }
                    {searchInformation.filterSummary &&
                    <div>
                        <b>Filters:</b> <br/>{searchInformation.filterSummary}
                    </div>
                    }
                </div>
                <Button size="sm" color="link" className="mb-4 mt-2 p-0" onClick={toggleMobile}>
                    <i className="far fa-envelope"/>
                    {" "}
                    Ontvang updates voor deze zoekopdracht
                </Button>
            </SmallScreenComponent>
            <LargeScreenComponent>
                <Button size="sm" color="primary" className="float-right" onClick={toggle}>
                    <i className="far fa-envelope"/>
                    {" "}
                    Ontvang updates voor deze zoekopdracht
                </Button>
            </LargeScreenComponent>
            <Modal isOpen={modal} toggle={toggle} centered={true} fade={false} backdropClassName="desktop-backdrop" contentClassName="modal-border">
                <ModalHeader toggle={toggle} >
                    <h5>Ontvang de nieuwste cottage's</h5>
                </ModalHeader>
                <ModalBody className="text-sm">
                    <Body searchInformation={searchInformation} setEmail={setEmail} data={data} loading={loading}/>
                </ModalBody>
                <ModalFooter>
                    {!data &&
                        <>
                            <Button color="primary" disabled={!validateEmail(email)}
                                    onClick={() => {
                                        onSend();
                                    }}
                            >
                                {validateEmail(email) ? <>Bevestigen</> : <>Voer een geldig email adres in</>}
                            </Button>{' '}
                            <Button color="secondary" onClick={toggle}>Niet nu</Button>
                        </>
                    }
                    {data &&
                        <Button color="primary" onClick={toggle}>Ok</Button>
                    }
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={mobileModal}
                toggle={toggleMobile}
                fade={false}
                contentClassName='modal-content-mobile'
                className="full-screen-modal modal-dialog-full-width"
            >
                <ModalHeader toggle={toggleMobile}>
                    <h6>De nieuwste cottage's</h6>
                </ModalHeader>
                <ModalBody className="p-3">
                    <Body searchInformation={searchInformation} setEmail={setEmail} data={data} loading={loading}/>
                </ModalBody>
                <div className="mobile-search-menu p-2">
                        {!data &&
                        <>
                            <Button block color="primary" disabled={!validateEmail(email)}
                                    onClick={() => {
                                        onSend();
                                    }}
                            >
                                {validateEmail(email) ? <>Bevestigen</> : <>Voer een geldig email adres in</>}
                            </Button>{' '}
                        </>
                        }
                        {data &&
                        <Button block color="primary" onClick={toggleMobile}>Ok</Button>
                        }
                </div>
            </Modal>
        </>
    );
}

export default EmailUpdatesButton;
